import { Injectable } from '@angular/core';
import * as backgroundColor from '../config/backgroundColor';
import * as color from '../config/colors';
import { isNil } from 'lodash';
import { EChartOption } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class ChartDarkModeService {

  constructor() { }

  // 设置地图的darkMode
  setMapDarkMode(chartOption) {
    chartOption.backgroundColor = backgroundColor.darkModeBGColor;
    chartOption.visualMap.textStyle.color = '#fff';
    if (chartOption.hasOwnProperty('geo')) {
      chartOption.geo.itemStyle = {
        normal: {
          // areaColor: 'transparent',//地图区域颜色
          areaColor: {
            type: 'radial',
            x: 0.5,
            y: 0.5,
            r: 0.8,
            colorStops: [{
              offset: 0,
              color: 'rgba(147, 235, 248, .5)' // 0% 处的颜色
            }, {
              offset: 1,
              color: 'rgba(147, 235, 248, .5)' // 100% 处的颜色
            }],
            globalCoord: false, // 缺省为 false
          },
          borderColor: '#3fdaff',//地图边框颜色
          borderWidth: 1,//边框宽度
          shadowColor: 'rgba(63, 218, 255, 0.5)',//阴影颜色
          shadowBlur: 30//图形阴影的模糊大小
        },
        emphasis: {//高亮状态下的多边形和标签样式。
          areaColor: '#2B91B7',//鼠标放在地图区域上的颜色
        }
      }
      chartOption.geo.emphasis.label.color = '#FFF'
    }
  }

  openDarkMode(chartOption, darkMode) {
    if (typeof (darkMode) === 'string') {
      chartOption['backgroundColor'] = darkMode;
    } else if (darkMode) {
      chartOption.color = color.darkModeColors;
      chartOption['backgroundColor'] = backgroundColor.darkModeBGColor;

      if (isNil(chartOption['title'])) {
        chartOption['title'] = {
          textStyle: {}
        }
      }
      chartOption.title.textStyle['color'] = color.darkModeTextColor;

      if (chartOption.hasOwnProperty('xAxis')) {
        chartOption.xAxis.forEach(e => {
          if (isNil(e['axisLabel'])) {
            e['axisLabel'] = {};
          }
          e['axisLabel']['color'] = color.darkModeTextColor;
          if (isNil(e['nameTextStyle'])) {
            e['nameTextStyle'] = {};
          }
          e['nameTextStyle']['color'] = color.darkModeTextColor;
        });
      }

      if (chartOption.hasOwnProperty('yAxis')) {
        chartOption.yAxis.forEach(e => {
          if (isNil(e['axisLabel'])) {
            e['axisLabel'] = {};
          }
          e['axisLabel']['color'] = color.darkModeTextColor;
          if (isNil(e['nameTextStyle'])) {
            e['nameTextStyle'] = {};
          }
          e['nameTextStyle']['color'] = color.darkModeTextColor;
          if (isNil(e['splitLine'])) {
            e['splitLine'] = {
              lineStyle: {
                color: color.darkModeTextColor
              }
            };
          } else {
            if (isNil(e['splitLine']['lineStyle'])) {
              e['splitLine']['lineStyle'] = {
                color: color.darkModeTextColor
              }
            } else {
              e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
            }
          }
        });
      }
      // 图例文字颜色
      if (isNil(chartOption.legend['textStyle'])) {
        chartOption.legend['textStyle'] = {
          color: color.darkModeTextColor
        };
      } else {
        chartOption.legend['textStyle']['color'] = color.darkModeTextColor;
      }
      // 翻页文字颜色
      if (!chartOption.legend.hasOwnProperty('pageTextStyle')) {
        chartOption.legend.pageTextStyle = { color: color.darkModeTextColor };
      } else {
        chartOption.legend['pageTextStyle']['color'] = color.darkModeTextColor;
      }
      // 翻页按钮颜色
      chartOption.legend['pageIconColor'] = '#aaa'
      chartOption.legend['pageIconInactiveColor'] = "#2f4554"

      if (chartOption && chartOption.hasOwnProperty('series') && Array.isArray(chartOption.series)) {
        chartOption.series.forEach(e => {
          if (isNil(e['label'])) {
            e['label'] = {};
          }
          e['label']['color'] = color.darkModeTextColor;
        });
      }

    }
  }

  openPieDarkMode(chartOption, darkMode) {
    if (typeof (darkMode) === 'string') {
      chartOption['backgroundColor'] = darkMode;
    } else if (darkMode) {
      chartOption.color = color.darkModeColors;
      chartOption['backgroundColor'] = backgroundColor.darkModeBGColor;

      // 图例文字颜色
      if (chartOption.legend.hasOwnProperty('textStyle')) {
        chartOption.legend['textStyle'] = {
          color: color.darkModeTextColor
        };
      } else {
        chartOption.legend['textStyle']['color'] = color.darkModeTextColor;
      }
      // 翻页文字颜色
      if (!chartOption.legend.hasOwnProperty('pageTextStyle')) {
        chartOption.legend.pageTextStyle = { color: color.darkModeTextColor };
      } else {
        chartOption.legend['pageTextStyle']['color'] = color.darkModeTextColor;
      }
      // 翻页按钮颜色
      chartOption.legend['pageIconColor'] = '#aaa'
      chartOption.legend['pageIconInactiveColor'] = "#2f4554"

      if (isNil(chartOption['textStyle'])) {
        chartOption['textStyle'] = {};
      }
      chartOption['textStyle']['color'] = color.darkModeTextColor;
      if (isNil(chartOption.legend['textStyle'])) {
        chartOption.legend['textStyle'] = {
          color: color.darkModeTextColor
        };
      } else {
        chartOption.legend['textStyle']['color'] = color.darkModeTextColor;
      }

      if (isNil(chartOption['title'])) {
        chartOption['title'] = {
          textStyle: {}
        }
      }
      chartOption.title.textStyle['color'] = color.darkModeTextColor;

      chartOption.series.forEach(e => {
        if (isNil(e['label'])) {
          e['label'] = {};
        }
        e['label']['color'] = color.darkModeTextColor;
      });
    }
  }

  /* 
    开启暗色模式 (各个部分分别设置)
  */

  chartBackgroundColorDarkMode(chartOption) {
    chartOption.background = backgroundColor.darkModeBGColor;
  }

  xAxisDarkMode(xAxisOption: EChartOption.XAxis[]) {
    xAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }

  yAxisDarkMode(yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }

  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    })
  }

  legendDarkMode(legendOption: EChartOption.Legend) {
    if (isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }


}
